var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useMemo, useState } from "react";
import { DatagridConfigurable, List, TextField, TextInput, useRefresh, useNotify, FunctionField, BooleanInput, DateInput, } from "react-admin";
import { useTenantStore } from "@/providers/TenantContextProvider";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ListActions } from "@/components/ListActions";
import { Chip, Tooltip, Typography } from "@mui/material";
import { Dialog } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
import { ActionsColumn } from "@/components/ActionButons";
import { AuthContext } from "@/providers/AuthContextProvider";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { USER_PROFILE_ATTRIBUTES } from "@/queries/GetUserProfileAttributes";
import { getTranslationLabel, userBasicInfo } from "@/services/UserService";
import CustomDateField from "../User/CustomDateField";
import { styled } from "@mui/material/styles";
import SelectArea from "@/components/area/SelectArea";
import ElectionHeader from "@/components/ElectionHeader";
import { CHANGE_APPLICATION_STATUS } from "@/queries/ChangeApplicationStatus";
import { useMutation, useQuery } from "@apollo/client";
import { PreloadedList } from "./PreloadedList";
import { convertToSnakeCase, convertToCamelCase, convertOneToSnakeCase } from "./UtilsApprovals";
import { ApplicationsError } from "@/types/applications";
var StyledChip = styled(Chip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 4px;\n"], ["\n    margin: 4px;\n"])));
var StyledNull = styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: block;\n    padding-left: 18px;\n"], ["\n    display: block;\n    padding-left: 18px;\n"])));
export var ListApprovalsMatches = function (_a) {
    var _b;
    var electionEventId = _a.electionEventId, electionId = _a.electionId, task = _a.task, goBack = _a.goBack;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var notify = useNotify();
    var refresh = useRefresh();
    var _c = React.useState(false), openApproveModal = _c[0], setOpenApproveModal = _c[1];
    var _d = useState(), userId = _d[0], setUserId = _d[1];
    var authContext = useContext(AuthContext);
    // const canEditUsers = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_WRITE)
    var approveVoter = useMutation(CHANGE_APPLICATION_STATUS)[0];
    var userApprovalInfo = Object.entries(convertToSnakeCase(task.applicant_data)).map(function (_a) {
        var key = _a[0], value = _a[1];
        return key;
    });
    var searchAttrs = (_b = task === null || task === void 0 ? void 0 : task.annotations) === null || _b === void 0 ? void 0 : _b["search-attributes"].split(",").map(function (s) { return convertOneToSnakeCase(s); });
    var userAttributes = useQuery(USER_PROFILE_ATTRIBUTES, {
        variables: {
            tenantId: tenantId,
            electionEventId: electionEventId,
        },
    }).data;
    var defaultFilters = useMemo(function () {
        var _a, _b;
        if (!(userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes)) {
            return {};
        }
        var filters = {};
        for (var _i = 0, _c = userAttributes.get_user_profile_attributes; _i < _c.length; _i++) {
            var attr = _c[_i];
            if (attr.name && searchAttrs.includes("".concat(attr.name))) {
                filters[attr.name] = { IsLike: "" };
                filters[attr.name].IsLike =
                    (_b = (_a = task.applicant_data) === null || _a === void 0 ? void 0 : _a[convertToCamelCase(attr.name)]) !== null && _b !== void 0 ? _b : "";
            }
        }
        return filters;
    }, [userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes, searchAttrs, task.applicant_data]);
    var Filters = useMemo(function () {
        var filters = [];
        if (userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) {
            filters = userAttributes.get_user_profile_attributes.map(function (attr) {
                var _a, _b;
                //covert to valid source string (if attr name is for example sequent.read-only.otp-method)
                var source = (_a = attr.name) === null || _a === void 0 ? void 0 : _a.replaceAll(".", "%");
                if (((_b = attr.annotations) === null || _b === void 0 ? void 0 : _b.inputType) === "html5-date") {
                    return (_jsx(DateInput, { source: "attributes.".concat(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t) }, attr.name));
                }
                return (_jsx(TextInput, { source: attr.name && userBasicInfo.includes(attr.name)
                        ? "".concat(attr.name, ".IsLike")
                        : "attributes.".concat(source), label: getTranslationLabel(attr.name, attr.display_name, t) }, attr.name));
            });
            filters.push(_jsx(BooleanInput, { source: "enabled" }, "enabled"));
            filters.push(_jsx(BooleanInput, { source: "email_verified" }, "email_verified"));
            if (electionEventId) {
                filters.push(_jsx(SelectArea, { tenantId: tenantId, electionEventId: electionEventId, source: "attributes.area-id", label: String(t("usersAndRolesScreen.users.fields.area")) }));
            }
            if (electionEventId && !electionId) {
                filters.push(_jsx(BooleanInput, { source: "has_voted", label: String(t("usersAndRolesScreen.users.fields.has_voted")) }, "has_voted"));
            }
        }
        return filters;
    }, [userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes]);
    var approveAction = function (id) {
        if (!electionEventId && authContext.userId === id) {
            return;
        }
        setOpenApproveModal(true);
        setUserId(id);
    };
    var confirmApproveAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, errors, errorMessage;
        var _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, approveVoter({
                        variables: {
                            tenant_id: tenantId,
                            id: task === null || task === void 0 ? void 0 : task.id,
                            user_id: userId,
                            area_id: task === null || task === void 0 ? void 0 : task.area_id,
                            election_event_id: electionEventId,
                        },
                    })];
                case 1:
                    _a = _g.sent(), data = _a.data, errors = _a.errors;
                    if (((_b = data === null || data === void 0 ? void 0 : data.ApplicationChangeStatus) === null || _b === void 0 ? void 0 : _b.error) || errors) {
                        errorMessage = ((_c = data === null || data === void 0 ? void 0 : data.ApplicationChangeStatus) === null || _c === void 0 ? void 0 : _c.error) &&
                            ((_d = data === null || data === void 0 ? void 0 : data.ApplicationChangeStatus) === null || _d === void 0 ? void 0 : _d.error) === ApplicationsError.APPROVED_VOTER
                            ? t("approvalsScreen.notifications.VoterApprovedAlready")
                            : t("approvalsScreen.notifications.approveError");
                        notify(errorMessage, { type: "error" });
                        console.log("Error approve user: ".concat(errors !== null && errors !== void 0 ? errors : "", " ").concat((_f = (_e = data === null || data === void 0 ? void 0 : data.ApplicationChangeStatus) === null || _e === void 0 ? void 0 : _e.error) !== null && _f !== void 0 ? _f : ""));
                        return [2 /*return*/];
                    }
                    notify(t("approvalsScreen.notifications.approveSuccess"), { type: "success" });
                    setUserId(undefined);
                    goBack();
                    return [2 /*return*/];
            }
        });
    }); };
    var actions = [
        {
            icon: (_jsx(Tooltip, { title: String(t("common.label.approve")), placement: "right", children: _jsx(CheckCircleOutlineIcon, { color: "success", className: "approve-voter-icon", sx: {
                        "cursor": "pointer",
                        "transform": "scale(1.2)",
                        "width": "48px",
                        "padding": "1px",
                        "borderRadius": "4px",
                        "backgroundColor": "rgba(0, 128, 0, 0.1)",
                        "transition": "transform 0.2s, background-color 0.2s, box-shadow 0.2s",
                        "&:hover": {
                            backgroundColor: "rgba(0, 128, 0, 0.2)",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            transform: "scale(1.2)",
                        },
                    } }) })),
            action: approveAction,
            showAction: function () { return (task === null || task === void 0 ? void 0 : task.status) === "PENDING" || (task === null || task === void 0 ? void 0 : task.status) === "REJECTED"; },
            label: t("common.label.delete"),
            className: "approve-voter-icon",
        },
    ];
    var Empty = function () { return (_jsx(ResourceListStyles.EmptyBox, { children: _jsx(Typography, { variant: "h4", paragraph: true, children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".emptyHeader")) }) })); };
    var listFields = useMemo(function () {
        var basicInfoFields = [];
        var attributesFields = [];
        var omitFields = [
            "id",
            "email_verified",
            "username",
            "emailAndOrMobile",
            "sequent.read-only.mobile-number",
            "sequent.read-only.otp-method",
            "embassy",
            "country",
            "sequent.read-only.id-card-type",
            "sequent.read-only.id-card-number",
            "sequent.read-only.id-card-number-validated",
            "authorized-election-ids",
        ];
        userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes.forEach(function (attr) {
            if (attr.name && userApprovalInfo.includes(attr.name)) {
                basicInfoFields.push(attr);
            }
            else {
                omitFields.push("attributes['".concat(attr.name, "']"));
                attributesFields.push(attr);
            }
        });
        return { basicInfoFields: basicInfoFields, attributesFields: attributesFields, omitFields: omitFields };
    }, [userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes]);
    var renderFields = function (fields) {
        return fields.map(function (attr) {
            var _a;
            if (((_a = attr.annotations) === null || _a === void 0 ? void 0 : _a.inputType) === "html5-date") {
                return (_jsx(FunctionField, { source: "attributes['".concat(attr.name, "']"), label: getTranslationLabel(attr.name, attr.display_name, t), render: function (record, source) {
                        return (_jsx(CustomDateField, { base: "attributes", source: "".concat(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t), emptyText: "-" }, attr.name));
                    } }, attr.name));
            }
            else if (attr.multivalued) {
                return (_jsx(FunctionField, { label: getTranslationLabel(attr.name, attr.display_name, t), render: function (record, source) {
                        var value = attr.name && userApprovalInfo.includes(attr.name)
                            ? record[attr.name]
                            : (attr === null || attr === void 0 ? void 0 : attr.name)
                                ? record.attributes[attr === null || attr === void 0 ? void 0 : attr.name]
                                : "-";
                        return (_jsx(_Fragment, { children: value ? (value.map(function (item, index) { return (_jsx(StyledChip, { label: item }, index)); })) : (_jsx(StyledNull, { children: "-" })) }));
                    } }, attr.name));
            }
            if (attr.name) {
                return (_jsx(TextField, { source: userBasicInfo.includes(attr.name)
                        ? attr.name
                        : "attributes['".concat(attr.name, "']"), label: getTranslationLabel(attr.name, attr.display_name, t), emptyText: "-" }, attr.name));
            }
            else {
                return null;
            }
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: "approvalsScreen.title", subtitle: "approvalsScreen.subtitle" }), _jsx(List, { resource: "user", empty: _jsx(Empty, {}), actions: _jsx(ListActions, { withImport: false, withExport: false }), filter: {
                    tenant_id: tenantId,
                    election_event_id: electionEventId,
                    election_id: electionId,
                }, storeKey: false, filters: Filters, filterDefaultValues: defaultFilters, disableSyncWithLocation: true, children: _jsx(PreloadedList, { defaultFilters: defaultFilters, resource: "user", children: (userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) && (_jsxs(DatagridConfigurable, { omit: listFields.omitFields, bulkActionButtons: false, children: [_jsx(TextField, { source: "id", sx: { display: "block", width: "280px" } }), renderFields(listFields === null || listFields === void 0 ? void 0 : listFields.basicInfoFields), renderFields(listFields === null || listFields === void 0 ? void 0 : listFields.attributesFields), _jsx(ActionsColumn, { actions: actions, label: String(t("common.label.actions")) })] })) }) }), _jsx(Dialog, { variant: "info", open: openApproveModal, ok: String(t("common.label.approve")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmApproveAction();
                    }
                    setOpenApproveModal(false);
                }, children: t("approvalsScreen.approve.body") })] }));
};
var templateObject_1, templateObject_2;
